export var MonthFormat=/*#__PURE__*/function(a){return a.SHORT="short",a.LONG="long",a}({});